import { render, staticRenderFns } from "./proposal-resource-item.vue?vue&type=template&id=14769664&"
import script from "./proposal-resource-item.vue?vue&type=script&lang=js&"
export * from "./proposal-resource-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports